import {
  OnboardingFail,
  OnboardingPartnerServiceMethods,
  OnboardingResponse,
  OnboardingServices,
} from 'clickNgo/configs/service/onboarding'
import { WebSocketStoreKeys } from 'clickNgo/configs/service/ws'
import { getAccessToken } from 'cng-common/helpers/access'
import WebSocketStore from 'core/classes/services/WebSocketStore'

import { IPartner } from '../models'

import { invalidatePartnerDataCache } from './cache'

type UpdatePartnerResponse = Pick<
  IPartner,
  | 'entryId406'
  | 'entryId502'
  | 'workflowStatus'
  | 'legalWorkflowStatus'
  | 'modifiedValues'
  | 'legalModifiedValues'
  | 'partnerId'
  | 'locationId'
>

export const updatePartner = async (partner: IPartner) => {
  const token = getAccessToken() || ''
  const payload = partner
  const wsClient = WebSocketStore.get(WebSocketStoreKeys.Onboarding)

  const response = (await wsClient.call({
    service: OnboardingServices.Partner,
    action: OnboardingPartnerServiceMethods.Update,
    payload,
    withoutTokenRefresh: true,
    isAuth: true,
    returnError: true,
    token,
  })) as OnboardingResponse<OnboardingFail, UpdatePartnerResponse>

  invalidatePartnerDataCache(partner.partnerId)

  return response
}
